export default __webpack_public_path__ + "static/media/ruffles.d5b67e93.svg";